import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Tabs } from '@ui/components/Tabs';

const entranceTabs: {
  value: 'Open' | 'Moderated';
  label: string;
  disabled?: boolean;
}[] = [
  { value: 'Open', label: 'Открытый' },
  { value: 'Moderated', label: 'С модерацией' },
];

export function EntranceInput() {
  const { control } = useFormContext<{ entrance?: 'Open' | 'Moderated' }>();

  return (
    <FormRow>
      <FormLabel>Вход в клуб</FormLabel>
      <FormInput>
        <Controller
          name="entrance"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <Tabs tabs={entranceTabs} value={value} onChange={onChange} disabled={disabled} />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
